import type { DistributorLimitations } from "src/services/distributorService";

export type CustomerLimitGuardKey =
  | "automations"
  | "notifications"
  | "users"
  | "recipients"
  | "notificationsPerMonth";

const distributorFieldByGuardKey: Record<CustomerLimitGuardKey, keyof DistributorLimitations> = {
  automations: "maxAutomations",
  notifications: "maxNotifications",
  users: "maxUsers",
  recipients: "maxRecipients",
  notificationsPerMonth: "maxInfoNotificationsPerMonth",
};

export const limitReachedTitleKeyByGuardKey: Record<CustomerLimitGuardKey, string> = {
  automations: "maximum_automation_limit_reached",
  notifications: "maximum_notification_settings_limit_reached",
  users: "maximum_user_limit_reached",
  recipients: "maximum_recipient_limit_reached",
  notificationsPerMonth: "maximum_info_notification_limit_reached",
};

export const limitReachedDescriptionKeyByGuardKey: Record<CustomerLimitGuardKey, string> = {
  automations: "maximum_automation_limit_reached_description",
  notifications: "maximum_notification_settings_limit_reached_description",
  users: "maximum_user_limit_reached_description",
  recipients: "maximum_recipient_limit_reached_description",
  notificationsPerMonth: "maximum_info_notification_limit_reached_description",
};

export const getDistributorLimitByGuardKey = (
  limits: Partial<DistributorLimitations> | null,
  key: CustomerLimitGuardKey
) => {
  const rawValue = limits?.[distributorFieldByGuardKey[key]];
  if (rawValue === null || rawValue === undefined) return null;

  const value = Number(rawValue);

  return Number.isFinite(value) ? value : null;
};

export const isCustomerLimitReached = (
  currentValue: number,
  maxValue: number | null,
  remaining?: number | null
) =>
  remaining !== null && remaining !== undefined
    ? remaining <= 0
    : maxValue !== null && maxValue >= 0 && currentValue >= maxValue;
